import { RECORD_DATA_MANAGER } from "../../data";

export default {
    namespaced: true,
    state: {
        scrollToIndex: 0,
        recordCurFirstL: '',
        recordLetterList: [],
        recordLetterData: {},
    },
    mutations: {},
    actions: {
        setRecordLetterList({ state }, letterList) {
            state.scrollToIndex = 0;
            state.recordLetterList = letterList;
            state.recordCurFirstL = state.recordLetterList[0];
        },
        updateRecordLetterListByList({ state }, letterList) {
            state.scrollToIndex = 0;
            state.recordLetterList = RECORD_DATA_MANAGER.updateRecordLetterList(state.recordLetterList, letterList);
            state.recordCurFirstL = state.recordLetterList[0];
            // state.recordLetterData = RECORD_DATA_MANAGER.updateRecordLetterData(state.recordLetterData, resultData.letter.letterObject);
        }
    }
}